import { TabWishlist } from 'components/user/user-detail/tab-wishlist/TabWishlist'
import { INITIAL_DATA_FILTER } from 'configs/user/user-detail/configTableWishlist'
import { useFetch } from 'services/useFetch'
import { API_USER } from 'services/apiUser'
import { useEffect } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { getAllQueryParams, setQueryParams } from 'utils/utils'

export const TabWishlistContainer = ({ id }) => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = getAllQueryParams(searchParams)
    const {
        data: wishlist,
        fetching: getWishListApi,
        isLoading,
    } = useFetch({ ...API_USER.WISHLIST, initPathVariable: id }, INITIAL_DATA_FILTER)

    useEffect(() => {
        const { tabName, userId, ...queryParams } = query
        getWishListApi({ ...queryParams })
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const props = {
        dataList: wishlist?.data,
        query,
        onChangeQuery,
        isLoading,
    }

    return <TabWishlist {...props} />
}
